/****************************************************
 * Module Name:  pricingApprovalModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import { Box, Button, Typography } from "@mui/material";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import logo from '../../images/pansuriya.jpg'

function PricingApproveModal({
  show,
  setShow,
  handleValidation,
  handleSave,
  selectedFilledData,
  stoneId,
  type,
}) {
  const [showError, setShowError] = useState(false);

  const stoneData = () => {
    let fArray = [];
    selectedFilledData.map((data) => {
      if (stoneId.includes(data.stoneid)) {
        fArray.push({ ...data, status: type });
      }
      return true;
    });
    return fArray;
  };

  const saveHandler = () => {
    let data = stoneData();
    if (handleSave) {
      if (handleValidation) {
        if (handleValidation(data)) {
          //need to add labId here and in the parent component if need for validation
          handleSave(data);
        } else {
          setShowError(true);
        }
      } else {
        handleSave(data);
      }
    }
  };

  const closeErrorDialog = () => {
    setShowError(false);
  };

  const handleClose = () => {
    setShow(false);
  };
  return (
    <div>
      <TabMenuSnackbar
        show={showError}
        message={
          <Box>
            Approve stone validation Failed
            <br /> Please enter correct data
          </Box>
        }
        variant={"error"}
        autoHide={false}
        handleClose={closeErrorDialog}
        title="Validation Failure"
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        size="lg"
        centered
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;
            {type === "APPROVE" ? "Approve Prices" : "Reject Prices"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Typography variant="h6" sx={{ textAlign: "center" }}>
            Are You sure you want to {type.toLowerCase()} these prices for these
            stones ?
          </Typography>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="contained"
            onClick={() => saveHandler()}
            type="Submit"
            sx={{ mr: 3 }}
          >
            Yes
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{ mr: 2 }}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PricingApproveModal;
